import EditorImg from 'lowcode/components/EditorImg';
import { Progress } from 'antd';
import EditorLink from 'lowcode/components/EditorLink';
import { IProductItem } from '../../../type';
import { useMembersStore } from '../../../MembersProvider';
import Button from '@/components/UI/Button';
import { useLang } from '@/i18n';
import { JpEcoCredits } from '@/components/MembersDay/FY2024/CommonElement/JpEcoCredits';
import getLocal from '@/app/utils/getLocal';
import { getProductUrl } from '@/service/membersday';
import { message } from '@/components/UI/Message';
import gtm from '@/utils/gtm';

export default ({ item, list_name }: { item: IProductItem; list_name: string }) => {
    const { isLogin, secKillisBegin } = useMembersStore();
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const handleClick = (id: string, title: string, toDetail?: boolean) => {
        // jp站不需要登录
        // if (!isLogin) {
        //     gtm.push({
        //         event: 'uaEvent',
        //         event_name: 'ecocredits_join_login',
        //         list_name,
        //         button_name: t('flashsale.product_price_buy_now'),
        //     });
        //     const pathname2 = location.pathname;
        //     location.href = `/${locale}/login?redirect=${pathname2}`;
        //     return;
        // }
        gtm.push({
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${t('flashsale.product_price_buy_now')}_${title}`,
        });

        getProductUrl(id, locale).then((res) => {
            if (res.code !== '0') {
                return message.error(res.message);
            }
            const { purchaseUrl, productUrl } = res.data;
            // toDetail区分点击标题还是购买
            const url = toDetail ? productUrl : purchaseUrl;

            if (isSafari) {
                location.href = url;
            } else {
                try {
                    window.open(url, '_blank');
                } catch {
                    location.href = url;
                }
            }
        });
    };

    const percent = Math.ceil((item.inventoryQuantity / item.displayInventoryQuantity) * 100) || 0;

    const btn = () => {
        if (!secKillisBegin) {
            return (
                <Button className="buy_button" disabled>
                    {t('flashsale.coming_soon_before')}
                </Button>
            );
        }
        if (item.inventoryQuantity === 0) {
            return (
                <Button className="buy_button" disabled>
                    {t('flashsale.sold_out')}
                </Button>
            );
        }
        return (
            <Button className="buy_button" onClick={() => handleClick(item.id, item.title)}>
                {t('flashsale.coming_soon')}
            </Button>
        );
    };

    return (
        <div className="product_item jp_card">
            {item.discountPercent && (
                <div className="off">
                    {item.discountPercent}%{t('flashsale.off')}
                </div>
            )}
            <div className="img">
                <EditorImg pc={item.imageUrl} />
            </div>
            <JpEcoCredits multiple={item.pointsMultiple} points={item.points} />
            <div className="name">{item.title}</div>
            {item.subtitle1 && <p className="subtitle">{item.subtitle1}</p>}
            <div>
                <div className="price_jp">
                    大特価:
                    <span className="number">{item.memberPrice || item.price}</span>
                    <span className="included">(税込)</span>
                    <span className="compareatnumber">通常価格：{item.compareAtPrice}(税込)</span>
                </div>
                <Progress className="line" status="active" showInfo={false} percent={percent} strokeColor={{ from: '#FFBD3C', to: '#FFBD3C' }} />
                <p className="stock">
                    残り{item.inventoryQuantity > 0 ? item.inventoryQuantity : 0}台<span>合計{item.displayInventoryQuantity}台</span>
                </p>
                <div className="tools">
                    <EditorLink
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: item.title,
                            position: 'Product Preview',
                        }}
                        style={{ width: '100%' }}
                        href={item.productUrl}
                        target="_blank"
                    >
                        <Button className="buy_button learn_more">{t('product_price_learn_more')}</Button>
                    </EditorLink>
                    {btn()}
                </div>
            </div>
        </div>
    );
};
